<template>
  <div class="date-picker">
    <!--<div class="input-wrapper" @mouseenter="showCancel = true" @mouseleave="showCancel = false">-->
    <!--<div class="input" @click="togglePanel" v-text="range ? value[0] + ' &#45;&#45; ' + value[1] : value"></div>-->
    <!--<transition name="fade">-->
    <!--<div class="cancel-btn" v-show="!showCancel">-->
    <!--<Icon name="calendar"></Icon>-->
    <!--</div>-->
    <!--</transition>-->
    <!--<transition name="fade">-->
    <!--<div class="cancel-btn" v-show="showCancel" @click="clear">-->
    <!--<Icon name="times"></Icon>-->
    <!--</div>-->
    <!--</transition>-->
    <!--</div>-->
    <!--<transition name="toggle">-->
    <div class="date-panel" v-show="panelState" :style="coordinates" v-bind:class="{'edit': edit}">
      <div class="panel-header" v-show="panelType !== 'year'">
        <div class="arrow-left" @click="prevMonthPreview()">
          <div class="arrow-icon">
            <div class="left-icon"></div>
          </div>
        </div>
        <div class="year-month-box">
          <div class="month-box" @click="chType('month')">{{tmpMonth + 1 | month(language)}}</div>
          <div class="year-box" @click="chType('year')" v-text="tmpYear"></div>
        </div>
        <div class="arrow-right" @click="nextMonthPreview()">
          <div class="arrow-icon">
            <div class="right-icon"></div>
          </div>
        </div>
      </div>
      <div class="panel-header" v-show="panelType === 'year'">
        <div class="arrow-left" @click="chYearRange(0)">
          <div class="arrow-icon">
            <div class="left-icon"></div>
          </div>
        </div>
        <div class="year-range">
          <span v-text="yearList[0]"></span> - <span v-text="yearList[yearList.length - 1]"></span>
        </div>
        <div class="arrow-right" @click="chYearRange(1)">
          <div class="arrow-icon">
            <div class="right-icon"></div>
          </div>
        </div>
      </div>
      <div class="type-year" v-show="panelType === 'year'">
        <ul class="year-list">
          <li v-for="item in yearList"
              v-text="item"
              :class="{selected: isSelected('year', item), invalid: validateYear(item)}"
              @click="selectYear(item)"
          >
          </li>
        </ul>
      </div>
      <div class="type-month" v-show="panelType === 'month'">
        <ul class="month-list">
          <li v-for="(item, index) in monthList"
              :class="{selected: isSelected('month', index), invalid: validateMonth(index)}"
              @click="selectMonth(index)"
          >
            {{item | month(language)}}
          </li>
        </ul>
      </div>
      <div class="type-date" v-show="panelType === 'date'">
        <ul class="weeks">
          <li v-for="item in weekList">{{item | week(language)}}</li>
        </ul>
        <ul class="date-list">
          <li v-for="(item, index) in dateList"
              :class="{preMonth: item.previousMonth, nextMonth: item.nextMonth,
                                invalid: validateDate(item), firstItem: (index % 7) === 0}"
              @click="selectDate(item)">
            <div class="message"
                 :class="{selected: isSelected('date', item), blocked: (lockedDates.indexOf(item.string) >= 0)}">
              <div class="had-event" v-if="dateRangeHasData.indexOf(item.string) >= 0"></div>
              <div class="bg"></div>
              <span v-text="item.value"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--</transition>-->
  </div>
</template>

<script>
  /* eslint-disable no-throw-liter
  al,key-spacing,space-before-function-paren,space-before-blocks,operator-linebreak,keyword-spacing,padded-blocks,one-var,no-unneeded-ternary,object-property-newline,no-duplicate-case,comma-spacing,semi */
  import 'vue-awesome/icons/calendar';
  import 'vue-awesome/icons/times';
  import Icon from 'vue-awesome/components/Icon';
  import moment from 'moment';

  export default {
    name: 'calendar-date-picker',
    data () {
      let now = new Date();
      let startDate, endDate;
      if (this.range) {
        startDate = this.value[0] ? new Date(this.value[0]) : now;
        endDate = this.value[1] ? new Date(this.value[1]) : now;
      } else {
        startDate = endDate = this.value ? new Date(this.value) : now;
      }
      return {
        showCancel: false,
        panelState: true,
        panelType: 'date',
        coordinates: {},
        year: endDate.getFullYear(),
        month: endDate.getMonth(),
        date: endDate.getDate(),
        tmpYear: endDate.getFullYear(),
        tmpMonth: endDate.getMonth(),
        tmpStartYear: startDate.getFullYear(),
        tmpStartMonth: startDate.getMonth(),
        tmpStartDate: startDate.getDate(),
        tmpEndYear: endDate.getFullYear(),
        tmpEndMonth: endDate.getMonth(),
        tmpEndDate: endDate.getDate(),
        minYear: Number,
        minMonth: Number,
        minDate: Number,
        maxYear: Number,
        maxMonth: Number,
        maxDate: Number,
        yearList: Array.from({length: 12}, (value, index) => new Date().getFullYear() + index),
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        weekList: [0, 1, 2, 3, 4, 5, 6],
        rangeStart: false,
        dateEnum: {
          month: 0,
          day: 1,
          year: 2
        },
        startDate: '',
        endDate: ''
      }
    },
    props: {
      language: {default: 'en'},
      min: {default: '01/01/2016'},
      max: {default: '31/12/2035'},
      value: {
        type: [String, Array],
        default: ''
      },
      range: {
        type: Boolean,
        default: false
      },
      metaData: {
        type: Object,
        default: null
      },
      showLeft: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      edit: {
        type: Boolean,
        default: false
      },
      datesHasData: {
        type: Array,
        default: []
      },
      lockedDates: {
        type: Array,
        default: []
      },
      selectedDate: {
        type: Object,
        default: moment()
      },
      dateRangeHasData: {
        type: Array,
        default: []
      }
    },
    components: {
      Icon
    },
    methods: {
      togglePanel () {
        this.panelState = !this.panelState;
        this.rangeStart = false
      },
      isSelected (type, item) {
        switch (type) {
          case 'year':
            if (!this.range) return item === this.tmpYear;
            return (new Date(item, 0).getTime() >= new Date(this.tmpStartYear, 0).getTime()
              && new Date(item, 0).getTime() <= new Date(this.tmpEndYear, 0).getTime());
          case 'month':
            if (!this.range) return item === this.tmpMonth && this.year === this.tmpYear;
            return (new Date(this.tmpYear, item).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth).getTime()
              && new Date(this.tmpYear, item).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth).getTime());
          case 'date':
            return item.string === this.selectedDate.format('MM/DD/YYYY');
        }
      },
      chType (type) {
        this.panelType = type
      },
      chYearRange (next) {
        if (next) {
          this.yearList = this.yearList.map((i) => i + 12)
        } else {
          this.yearList = this.yearList.map((i) => i - 12)
        }
      },
      prevMonthPreview () {
        this.tmpMonth--;
        if (this.tmpMonth < 0){
          this.tmpMonth = 11;
          this.tmpYear--;
        }
      },
      nextMonthPreview () {
        this.tmpMonth++;
        if (this.tmpMonth >= 12){
          this.tmpMonth = 0;
          this.tmpYear++;
        }
      },
      selectYear (year) {
        if (this.validateYear(year)) return;
        this.tmpYear = year;
        this.panelType = 'date'
      },
      selectMonth (month) {
        if (this.validateMonth(month)) return;
        this.tmpMonth = month;
        this.panelType = 'date'
      },
      selectDate (date) {
        setTimeout(() => {
          if (this.validateDate(date)) return;
          if (date.previousMonth) {
            if (this.tmpMonth === 0) {
              this.year -= 1;
              this.tmpYear -= 1;
              this.month = this.tmpMonth = 11
            } else {
              this.month = this.tmpMonth - 1;
              this.tmpMonth -= 1
            }
          } else if (date.nextMonth) {
            if (this.tmpMonth === 11) {
              this.year += 1;
              this.tmpYear += 1;
              this.month = this.tmpMonth = 0
            } else {
              this.month = this.tmpMonth + 1;
              this.tmpMonth += 1
            }
          }
          if (!this.range) {
            this.year = this.tmpYear;
            this.month = this.tmpMonth;
            this.date = date.value;
            let value = `${('0' + (this.month + 1)).slice(-2)}/${('0' + this.date).slice(-2)}/${this.tmpYear}`;
            if (this.metaData) {
              this.metaData.value = value;
              this.$emit('EVENT_GET_ROW_ITEM', this.metaData);
            }
            this.$emit('input', value);
            // this.panelState = false
          } else if (this.range && !this.rangeStart) {

            this.tmpEndYear = this.tmpStartYear = this.tmpYear;
            this.tmpEndMonth = this.tmpStartMonth = this.tmpMonth;
            this.tmpEndDate = this.tmpStartDate = date.value;

            this.rangeStart = true

          } else if (this.range && this.rangeStart) {

            this.tmpEndYear = this.tmpYear;
            this.tmpEndMonth = this.tmpMonth;
            this.tmpEndDate = date.value;

            let d1 = new Date(this.tmpStartYear, this.tmpStartMonth, this.tmpStartDate).getTime(),
              d2 = new Date(this.tmpEndYear, this.tmpEndMonth, this.tmpEndDate).getTime();
            if (d1 > d2) {
              let tmpY, tmpM, tmpD;
              tmpY = this.tmpEndYear;
              tmpM = this.tmpEndMonth;
              tmpD = this.tmpEndDate;

              this.tmpEndYear = this.tmpStartYear;
              this.tmpEndMonth = this.tmpStartMonth;
              this.tmpEndDate = this.tmpStartDate;

              this.tmpStartYear = tmpY;
              this.tmpStartMonth = tmpM;
              this.tmpStartDate = tmpD
            }
            let RangeStart = `${('0' + (this.tmpStartMonth + 1)).slice(-2)}/${('0' + this.tmpStartDate).slice(-2)}/${this.tmpStartYear}`;
            let RangeEnd = `${('0' + (this.tmpEndMonth + 1)).slice(-2)}/${('0' + this.tmpEndDate).slice(-2)}/${this.tmpEndYear}`;

            let value = [RangeStart, RangeEnd];
            if (this.metaData) {
              this.metaData.value = value;
              this.$emit('EVENT_GET_ROW_ITEM', this.metaData)
            }
            this.$emit('input', value);

            this.rangeStart = false;
            // this.panelState = false;
          }

          this.$emit('selectDate', date.string);

        }, 0);
      },
      validateYear (year) {
        return (year > this.maxYear || year < this.minYear)
      },
      validateMonth (month) {
        return !(new Date(this.tmpYear, month).getTime() >= new Date(this.minYear, this.minMonth - 1).getTime()
          && new Date(this.tmpYear, month).getTime() <= new Date(this.maxYear, this.maxMonth - 1).getTime());
      },
      validateDate (date) {
        let mon = this.tmpMonth;
        if (date.previousMonth) {
          mon -= 1
        } else if (date.nextMonth) {
          mon += 1
        }
        return !(new Date(this.tmpYear, mon, date.value).getTime() >= new Date(this.minYear, this.minMonth - 1, this.minDate).getTime()
          && new Date(this.tmpYear, mon, date.value).getTime() <= new Date(this.maxYear, this.maxMonth - 1, this.maxDate).getTime());
      },
      close (e) {
        if (!this.$el.contains(e.target)) {
          // this.panelState = false;
          this.rangeStart = false;
        }
      },
      clear () {
        this.$emit('input', this.range ? ['', ''] : '')
      },
      setToday () {
        this.selectedDate = moment();
        let today = {
          currentMonth: true,
          string: moment().format('MM/DD/YYYY'),
          value: moment().date()
        };
        this.selectDate(today);
        let startDate;
        let endDate;
        startDate = endDate = this.value ? new Date(this.value) : new Date();
        this.year = endDate.getFullYear();
        this.month = endDate.getMonth();
        this.date = endDate.getDate();
        this.tmpYear = endDate.getFullYear();
        this.tmpMonth = endDate.getMonth();
        this.tmpStartYear = startDate.getFullYear();
        this.tmpStartMonth = startDate.getMonth();
        this.tmpStartDate = startDate.getDate();
        this.tmpEndYear = endDate.getFullYear();
        this.tmpEndMonth = endDate.getMonth();
        this.tmpEndDate = endDate.getDate();
      },
      drawThisMonth () {
        let currentMonthLength = new Date(this.tmpYear, this.tmpMonth + 1, 0).getDate();
        let dateList = Array.from({length: currentMonthLength}, (val, index) => {
          return {
            currentMonth: true,
            value: index + 1,
            string: ('0' + (this.tmpMonth + 1)).slice(-2) + '/' + ('0' + (index + 1)).slice(-2) + '/' + this.tmpYear
          }
        });
        let startDay = new Date(this.tmpYear, this.tmpMonth, 1).getDay();
        let previousMongthLength = new Date(this.tmpYear, this.tmpMonth, 0).getDate();

        for (let i = 0, len = startDay; i < len; i++) {
          dateList = [{
            previousMonth: true,
            value: previousMongthLength - i,
            string: ('0' + (this.tmpMonth === 0 ? 12 : this.tmpMonth)).slice(-2) + '/' + ('0' + (previousMongthLength - i)).slice(-2) + '/' + (this.tmpMonth === 0 ? this.tmpYear - 1 : this.tmpYear)
          }].concat(dateList)
        }
        for (let i = dateList.length, item = 1; i < 42; i++, item++) {
          dateList[dateList.length] = {
            nextMonth: true,
            value: item,
            string: ('0' + (this.tmpMonth === 11 ? 1 : this.tmpMonth + 2)).slice(-2) + '/' + ('0' + (item)).slice(-2) + '/' + (this.tmpMonth === 11 ? this.tmpYear + 1 : this.tmpYear)
          }
        }
        this.startDate = dateList[0].string;
        this.endDate = dateList[dateList.length - 1].string;
        this.$emit('getDateRangeHasData', {
          startDate: dateList[0].string,
          endDate: dateList[dateList.length - 1].string
        });
        return dateList;
      }
    },
    watch: {
      min (v) {
        let minArr = v.split('/');
        this.minYear = Number(minArr[this.dateEnum.year]);
        this.minMonth = Number(minArr[this.dateEnum.month]);
        this.minDate = Number(minArr[this.dateEnum.day])
      },
      max (v) {
        let maxArr = v.split('/');
        this.maxYear = Number(maxArr[this.dateEnum.year]);
        this.maxMonth = Number(maxArr[this.dateEnum.month]);
        this.maxDate = Number(maxArr[this.dateEnum.day])
      },
      range (newVal, oldVal) {
        if (newVal === oldVal) return;
        if (newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'String') {
          this.$emit('input', ['', ''])
        }
        if (!newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'Array') {
          this.$emit('input', '')
        }
      },
      dateList () {
        this.$emit('getDateRangeHasData', {
          startDate: this.startDate,
          endDate: this.endDate
        });
      }
    },
    computed: {
      dateList: function () {
        return this.drawThisMonth();
      }
    },
    filters: {
      week: (item, lang) => {
        switch (lang) {
          case 'en':
            return {0: 'Su', 1: 'Mo', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sa'}[item];
          default:
            return item
        }
      },
      month: (item, lang) => {
        switch (lang) {
          case 'en':
            return {
              1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
              7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December'
            }[item];
          default:
            return item
        }
      }
    },
    mounted () {
      if (this.placeholder) {
        this.$emit('input', this.placeholder);
      }
      this.$nextTick(() => {
        if (this.showLeft) {
          this.coordinates = {left: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`}
        } else if (this.$el.parentNode.offsetWidth + this.$el.parentNode.offsetLeft - this.$el.offsetLeft <= 300) {
          this.coordinates = {right: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`}
        } else {
          this.coordinates = {left: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`}
        }
        let minArr = this.min.split('/');
        this.minYear = Number(minArr[this.dateEnum.year]);
        this.minMonth = Number(minArr[this.dateEnum.month]);
        this.minDate = Number(minArr[this.dateEnum.day]);

        let maxArr = this.max.split('/');
        this.maxYear = Number(maxArr[this.dateEnum.year]);
        this.maxMonth = Number(maxArr[this.dateEnum.month]);
        this.maxDate = Number(maxArr[this.dateEnum.day]);

        if (this.range) {
          if (Object.prototype.toString.call(this.value).slice(8, -1) !== 'Array') {
            throw new Error('Binding value must be an array in range mode.')
          }
          if (this.value.length) {
            let rangeStart = this.value[0].split('/');
            let rangeEnd = this.value[1].split('/');
            this.tmpStartYear = Number(rangeStart[this.dateEnum.year]);
            this.tmpStartMonth = Number(rangeStart[this.dateEnum.month]) - 1;
            this.tmpStartDate = Number(rangeStart[this.dateEnum.day]);

            this.tmpEndYear = Number(rangeEnd[this.dateEnum.year]);
            this.tmpEndMonth = Number(rangeEnd[this.dateEnum.month]) - 1;
            this.tmpEndDate = Number(rangeEnd[this.dateEnum.day])
          } else {
            this.$emit('input', ['', ''])
          }

        }
        //        if (!this.value) {
        //          this.$emit('input', '')
        //        }
        window.addEventListener('click', this.close)
      })
    },
    beforeDestroy () {
      window.removeEventListener('click', this.close)
    },
    created () {
      this.$bus.$on('set-today', this.setToday);
    }
  }
</script>

<style scoped lang='less'>
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .date-picker {
    position: relative;
    height: 320px;
  }

  .input-wrapper {
    border: 1px solid #D2D2D2;
    border-radius: 2px;
    vertical-align: middle;
    display: flex;
    justify-content: space-between;
    flex-flow: row nowrap;
    align-items: center;
    padding: 6px 10px 6px 4px;
    height: 20px;
    box-sizing: border-box;
  }

  .input {
    height: 20px;
    width: 100%;
    font-size: inherit;
    padding-left: 4px;
    box-sizing: border-box;
    outline: none;
  }

  .cancel-btn {
    height: 14px;
    width: 14px;
  }

  .date-panel {
    position: absolute;
    z-index: 5000;
    border: 1px solid #eee;
    box-sizing: border-box;
    width: 320px;
    padding: 5px 10px 10px;
    background-color: #fff;
    /*transform: translateY(-250px);*/
    /*&.edit {*/
    /*transform: translateY(-250px);*/
    /*}*/
  }

  .panel-header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
    border-bottom: 2px solid #FBFBFB;
    height: 50px;
  }

  .arrow-left, .arrow-right {
    flex: 1;
    font-size: 20px;
    line-height: 2;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .year-range {
    font-size: 20px;
    line-height: 2;
    flex: 3;
    display: flex;
    justify-content: center;
  }

  .year-month-box {
    flex: 3;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
  }

  .type-year, .type-month, .date-list {
    background-color: #fff;
  }

  .date-list {
    background-color: #ffffff;
  }

  .year-box, .month-box {
    transition: all ease .1s;
    font-family: "Open Sans", sans-serif;
    flex: 1;
    text-align: center;
    font-size: 15px;
    line-height: 2;
    cursor: pointer;
    background-color: #fff;
  }

  .year-list, .month-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    li {
      font-family: "Open Sans", sans-serif;
      transition: all .45s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
      cursor: pointer;
      text-align: center;
      font-size: 20px;
      width: 33%;
      padding: 10px 0;
      &:hover {
        background-color: #6ac1c9;
        color: #fff;
      }
      &.selected {
        background-color: #0097a7;
        color: #fff;
      }
      &.invalid {
        cursor: not-allowed;
        color: #D2D2D2;
      }
    }
  }

  .date-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .valid:hover {
      background-color: #eee;
    }
    li {
      transition: all ease .1s;
      cursor: pointer;
      box-sizing: border-box;
      border-bottom: 1px solid #fff;
      position: relative;
      margin: 2px;
      &:not(.firstItem) {
        margin-left: 10px;
      }
      .message {
        font-family: "Open Sans", sans-serif;
        font-weight: 300;
        font-size: 14px;
        position: relative;
        height: 30px;
        &.selected {
          .bg {
            /*background-color: #ff281c;*/
            border: 1px solid #00A4D6;
            border-radius: 4px;
          }
          span {
            color: #151b1e;
          }
        }
        &:not(.selected) {
          .bg {
            transform: scale(0);
            opacity: 0;
          }
          &:hover {
            .bg {
              background-color: #d8d8d8;
              transform: scale(1);
              opacity: .6;
            }
            span {
              color: #151b1e;
            }
          }
        }
        &.blocked {
          background-color: #FF3400;
          color: #fff;
        }
        .bg {
          height: 30px;
          width: 100%;
          transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
          position: absolute;
          z-index: 10;
          top: 0;
          left: 0;
        }
        span {
          position: absolute;
          z-index: 20;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
      }
      &.invalid {
        cursor: not-allowed;
        color: #D2D2D2;
      }
    }

  }

  .weeks {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
    li {
      font-weight: normal;
    }
  }

  .weeks, .date-list {
    width: 100%;
    text-align: center;
    li {
      font-family: "Open Sans", sans-serif;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
    .preMonth, .nextMonth {
      color: #D2D2D2;
    }
  }

  .date-list {
    li {
      color: #151b1e;
    }
    .preMonth, .nextMonth {
      color: #D2D2D2;
    }
    .had-event {
      height: 4px;
      width: 4px;
      background-color: #68B814;
      position: absolute;
      right: 2px;
      top: 2px;
    }
  }

  .toggle-enter, .toggle-leave-active {
    opacity: 0;
    transform: translateY(-10px);
  }

  .toggle-enter-active, .toggle-leave-active {
    transition: all ease .2s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
    transform: scale3d(0, 0, 0);
  }

  .fade-enter-active, .fade-leave-active {
    transition: all ease .1s;
  }

  .arrow-icon {
    height: 30px;
    width: 30px;
    line-height: 30px;
    border-radius: 50%;
    .left-icon {
      z-index: 7;
      width: 24px;
      height: 24px;
      background-color: #00A4D6;
      color: #00A4D6;
      -webkit-mask: url('../../../static/img/backward-line.svg') no-repeat center;
      mask: url('../../../static/img/backward-line.svg') no-repeat center;
      background: url('../../../static/img/backward-line-blue.svg');
    }
    .right-icon {
      z-index: 7;
      width: 24px;
      height: 24px;
      background-color: #00A4D6;
      color: #00A4D6;
      -webkit-mask: url('../../../static/img/forward-line.svg') no-repeat center;
      mask: url('../../../static/img/forward-line.svg') no-repeat center;
      background: url('../../../static/img/forward-line-blue.svg');
    }
  }

  .arrow-right {
    .arrow-icon {
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// CalendarDatePicker.vue?e59db9fa